import {useServiceApiQuery} from 'stores/hooks/query';
import utils from 'helpers/utils';

const path = utils.servicePath(import.meta.url);

export function useCollectionQuestionList ({collectionId, search, filter, sort, page, pageSize, ...rest}, queryOptions = {}) {
  return useServiceApiQuery(path, 'list', {collectionId, search, filter, sort, page, pageSize, ...rest}, queryOptions);
}
